import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

const getTakerMarketName = (takerMarket: TakerMarket) =>
  takerMarket.marketType
    ? `${takerMarket.makerDivisionName}-${takerMarket.legacyMarketId}`
    : takerMarket.makerDivisionName;

export default getTakerMarketName;
